import React, { useCallback } from 'react';
import { AssistantChatInput } from '../.././assistant-chat-input/AssistantChatInput';
import piEditorStyles from 'features/pi/view/uiManager/text-instances/pi-editor-content.module.scss';
import { useRef } from 'react';
import { IRichTextEditor } from '../../assistant-chat-input/RichTextEditor';
import { useTypewriter } from '../../../hooks/useTypewriter';
import { ChatLoader } from '../../../ChatLoader';
import { IConversationRun } from '../../../../model/ConversationRun';
import { RunStatus } from '../../../../services/AssistantDTOs';

type PiChatAnswerProps = {
    text: string;
    run: IConversationRun;
};

export const PiChatAnswer = ({ run, text }: PiChatAnswerProps) => {
    const status = run.status.get();
    const editorRef = useRef<IRichTextEditor | null>(null);
    useTypewriter(text, (newText) => {
        editorRef.current?.setContent(newText);
    }, status !== RunStatus.COMPLETED);

    const handleEditorCreated = useCallback((editor: IRichTextEditor) => {
        editorRef.current = editor;
    }, []);

    let component = <ChatLoader />;
    if (text.length) {
        component = <AssistantChatInput
            isReadOnly={true}
            textEditorContent={piEditorStyles.textEditorContent}
            onEditorReady={handleEditorCreated}
        />;
    }

    return component;
};
